import {
	CircleHelp,
	Database,
	Handshake,
	Lock,
	Logs,
	MessagesSquare,
	PanelsTopLeft,
	Send,
	Terminal,
	ToggleRight,
	Unplug,
	User
} from 'lucide-svelte';
import { SquareFunction } from 'lucide-svelte';

import { goto } from '$app/navigation';

import { commandBar } from './command-bar-state.svelte';

export function registerNavigationCommands() {
	commandBar.register('navigation', 'chats', {
		icon: MessagesSquare,
		title: 'Go to Chats',
		async onSelect() {
			await goto('/collections/chats');
		}
	});
	commandBar.register('navigation', 'prompts', {
		icon: Terminal,
		title: 'Go to Prompts',
		keywords: ['system prompt'],
		async onSelect() {
			await goto('/collections/prompts');
		}
	});
	commandBar.register('navigation', 'automations', {
		icon: ToggleRight,
		title: 'Go to Automations',
		async onSelect() {
			await goto('/collections/automations');
		}
	});
	commandBar.register('navigation', 'tools', {
		icon: SquareFunction,
		title: 'Go to tools',
		keywords: ['functions', 'context'],
		async onSelect() {
			await goto('/collections/tools');
		}
	});
	commandBar.register('navigation', 'providers', {
		icon: Unplug,
		title: 'Go to Providers',
		keywords: ['api'],
		async onSelect() {
			await goto('/collections/providers');
		}
	});
	commandBar.register('navigation', 'profile', {
		icon: User,
		title: 'Go to Profile',
		keywords: ['user', 'avatar'],
		async onSelect() {
			await goto('/settings/profile');
		}
	});
	commandBar.register('navigation', 'appearance', {
		icon: PanelsTopLeft,
		title: 'Go to Appearance',
		async onSelect() {
			await goto('/settings/appearance');
		}
	});
	commandBar.register('navigation', 'data', {
		icon: Database,
		title: 'Go to Data',
		keywords: ['storage', 'database', 'import', 'export', 'backup'],
		async onSelect() {
			await goto('/settings/data');
		}
	});
	commandBar.register('navigation', 'feedback', {
		icon: Send,
		title: 'Go to Feedback',
		keywords: ['bug report', 'contact'],
		async onSelect() {
			await goto('/about/feedback');
		}
	});
	commandBar.register('navigation', 'faq', {
		icon: CircleHelp,
		title: 'Go to FAQ',
		keywords: ['frequently asked questions'],
		async onSelect() {
			await goto('/about/faq');
		}
	});
	commandBar.register('navigation', 'changelog', {
		icon: Logs,
		title: 'Go to Change Log',
		keywords: ['release notes', 'update', 'version'],
		async onSelect() {
			await goto('/about/changelog');
		}
	});
	commandBar.register('navigation', 'privacy', {
		icon: Lock,
		title: 'Go to Privacy Policy',
		async onSelect() {
			await goto('/about/privacy');
		}
	});
	commandBar.register('navigation', 'terms', {
		icon: Handshake,
		title: 'Go to Terms & Conditions',
		async onSelect() {
			await goto('/about/terms');
		}
	});
}
